import { useEffect } from 'react';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://bullyproofmylife.com';

const schemas = [
  {
    id: 'schema-organization',
    data: {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "Bully Proof My Life",
      "url": `${SITE_URL}/`,
      "logo": "https://static.readdy.ai/image/93c3e079cd1f297eadf6098c3b0ef55d/c5fcb1dbae29388464febce36e760d64.png",
      "description": "Affordable legal protection membership for homeowners and landlords. Access real licensed attorneys for about $30/month.",
      "sameAs": []
    }
  },
  {
    id: 'schema-website',
    data: {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "name": "Bully Proof My Life",
      "url": `${SITE_URL}/`,
      "description": "Legal protection for homeowners and landlords — fight shady contractors, HOA boards, and insurance bullies with real attorneys for $30/month."
    }
  },
  {
    id: 'schema-service',
    data: {
      "@context": "https://schema.org",
      "@type": "Service",
      "name": "Legal Protection Membership for Homeowners & Landlords",
      "provider": {
        "@type": "Organization",
        "name": "Bully Proof My Life",
        "url": `${SITE_URL}/`
      },
      "description": "Flat-fee legal plan giving homeowners and landlords unlimited attorney consultations, demand letters, contract review, and trial defense for about $30/month.",
      "offers": {
        "@type": "Offer",
        "price": "30.00",
        "priceCurrency": "USD",
        "priceSpecification": {
          "@type": "UnitPriceSpecification",
          "price": "30.00",
          "priceCurrency": "USD",
          "unitText": "MONTH"
        }
      },
      "areaServed": {
        "@type": "Country",
        "name": "United States"
      },
      "serviceType": "Legal Protection Plan"
    }
  },
  {
    id: 'schema-faq',
    data: {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
        {
          "@type": "Question",
          "name": "What exactly do I get for $30/month?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "You get unlimited phone consultations with attorneys, contract and document review (up to 15 pages), demand letters sent on law firm letterhead, traffic ticket defense, trial defense (civil and criminal), IRS audit assistance, and 25% off additional legal services."
          }
        },
        {
          "@type": "Question",
          "name": "Is this real lawyers or just legal advice?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Real, licensed attorneys in your state. Not paralegals, not AI, not a call center reading scripts. When you call, you are talking to an actual attorney who can represent you in court if needed."
          }
        },
        {
          "@type": "Question",
          "name": "Can I cancel anytime?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "Yes. Month-to-month. No contracts, no cancellation fees. If you don't need it anymore, cancel. But most people keep it because $30/month is cheaper than one hour with a lawyer."
          }
        },
        {
          "@type": "Question",
          "name": "Does this work in my state?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "LegalShield operates in all 50 states and Canada. When you sign up, you are matched with attorneys licensed in your state who know your local laws."
          }
        },
        {
          "@type": "Question",
          "name": "Is this insurance or a membership?",
          "acceptedAnswer": {
            "@type": "Answer",
            "text": "It is a membership, not insurance. Insurance pays claims after something bad happens. This gives you access to attorneys before, during, and after problems arise. It is proactive legal protection, not reactive coverage."
          }
        }
      ]
    }
  }
];

export default function HomePageSchema() {
  useEffect(() => {
    const injected: HTMLScriptElement[] = [];

    schemas.forEach(({ id, data }) => {
      let el = document.getElementById(id) as HTMLScriptElement | null;
      if (!el) {
        el = document.createElement('script');
        el.id = id;
        el.type = 'application/ld+json';
        document.head.appendChild(el);
        injected.push(el);
      }
      el.textContent = JSON.stringify(data);
    });

    return () => {
      injected.forEach((el) => {
        if (el.parentNode) el.parentNode.removeChild(el);
      });
    };
  }, []);

  return null;
}